<template>
    <div class="default-layout-container flex-grow-1 overflow-y-auto">
        <div v-if="pageName || pageDescriptionToDisplay" class="page-header-wrapper mb-7">
            <div v-if="pageName" class="page-header-container d-flex align-center justify-space-between">
                <el-page-header v-if="goBackRouteName" @back="goBack()">
                    <template #content>
                        <h3 class="text-h5 font-weight-bold">
                            {{ pageName }}
                        </h3>
                    </template>
                </el-page-header>
                <h3 v-else class="text-h5 font-weight-bold">
                    {{ pageName }}
                </h3>
                <slot name="cta" />
            </div>
            <p v-if="pageDescriptionToDisplay" class="text-subtitle-2 mt-1">
                {{ pageDescriptionToDisplay }}
            </p>
        </div>
        <slot />
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useIndexStore } from "@/store/core/index"

const router = useRouter()
const indexStore = useIndexStore()
const props = defineProps<{
    pageName?: string
    goBackRouteName?: string
    description?: string
}>()
const pageDescriptionToDisplay = computed(() => props.description || indexStore.pageDescription)

const goBack = (): void => {
    router.push({ name: props.goBackRouteName })
}
</script>

<style lang="scss" scoped>
.default-layout-container {
    padding: 40px 30px;
    max-height: 100%;
}

@media screen and (min-width: 1800px) {
    .default-layout-container {
        padding: 40px 5vw;
    }
}
</style>
<style>
.page-header-container .el-page-header__title {
    line-height: 28px;
}
</style>
